import React from "react";
import {
  Truck,
  CreditCard,
  Package,
  Store,
  SmartphoneNfc,
  Landmark,
  Coins,
  Gift,
  Info
} from "lucide-react";

const ShippingPaymentPage = () => {
  const shippingOptions = [
    { id: "dpd", name: "DPD Kurýr", price: 149, icon: Truck },
    { id: "packeta_address", name: "Zásilkovna (Doručení na adresu)", price: 109, icon: Package },
    { id: "packeta_point", name: "Zásilkovna (Výdejní místo / Z-BOX)", price: 79, icon: Package },
    { id: "pickup", name: "Osobní odběr (Čáslav)", price: 0, icon: Store },
  ];

  const paymentOptions = [
    { id: "card", name: "Online platba kartou", price: 0, icon: CreditCard },
    { id: "apple", name: "Apple Pay", price: 0, icon: SmartphoneNfc },
    { id: "google", name: "Google Pay", price: 0, icon: SmartphoneNfc },
    { id: "bank", name: "Bankovní převod předem", price: 0, icon: Landmark },
    { id: "cod", name: "Dobírka (Platba při převzetí)", price: 49, icon: Coins },
  ];

  return (
    <div className="max-w-5xl mx-auto px-4 py-12 md:py-16 animate-in fade-in duration-300">
      <h1 className="text-3xl md:text-4xl font-bold text-[#2a3b4c] mb-8 text-center md:text-left">
        Doprava a platba
      </h1>

      {/* Banner Doprava Zdarma */}
      <div className="mb-10 p-5 bg-green-50 border-2 border-green-200 text-green-800 rounded-2xl flex flex-col md:flex-row items-center gap-4 font-bold shadow-sm">
        <div className="bg-white p-3 rounded-full shadow-sm text-green-600 shrink-0">
          <Gift className="w-7 h-7" />
        </div>
        <div className="text-center md:text-left">
          <span className="block text-lg md:text-xl">Doprava ZDARMA!</span>
          <span className="text-sm font-medium text-green-700 mt-1 block">
            Při objednávce nad 5 000 Kč od nás máte doručení na naše náklady. (Platí pro všechny způsoby doručení, příplatek za případnou dobírku zůstává).
          </span>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-8 md:gap-10">
        
        {/* ----- DOPRAVA ----- */}
        <div className="bg-white p-6 md:p-8 rounded-2xl border border-slate-200 shadow-sm">
          <h2 className="text-2xl font-bold mb-6 flex items-center gap-3 text-[#2a3b4c]">
            <Truck className="w-7 h-7 text-green-600" /> Možnosti dopravy
          </h2>
          <div className="space-y-3">
            {shippingOptions.map((opt) => {
              const Icon = opt.icon;
              return (
                <div key={opt.id} className="flex items-center justify-between p-4 rounded-xl border-2 border-slate-100 hover:border-slate-200 hover:bg-slate-50 transition-colors">
                  <div className="flex items-center gap-4">
                    <div className="p-2.5 bg-slate-100 text-slate-500 rounded-xl">
                      <Icon className="w-5 h-5" />
                    </div>
                    <span className="font-bold text-slate-800">{opt.name}</span>
                  </div>
                  <span className="font-black text-slate-600 whitespace-nowrap ml-4">
                    {opt.price === 0 ? "Zdarma" : `${opt.price} Kč`}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        {/* ----- PLATBA ----- */}
        <div className="bg-white p-6 md:p-8 rounded-2xl border border-slate-200 shadow-sm">
          <h2 className="text-2xl font-bold mb-6 flex items-center gap-3 text-[#2a3b4c]">
            <CreditCard className="w-7 h-7 text-green-600" /> Způsoby platby
          </h2>
          <div className="space-y-3">
            {paymentOptions.map((opt) => {
              const Icon = opt.icon;
              return (
                <div key={opt.id} className="flex items-center justify-between p-4 rounded-xl border-2 border-slate-100 hover:border-slate-200 hover:bg-slate-50 transition-colors">
                  <div className="flex items-center gap-4">
                    <div className="p-2.5 bg-slate-100 text-slate-500 rounded-xl">
                      <Icon className="w-5 h-5" />
                    </div>
                    <span className="font-bold text-slate-800">{opt.name}</span>
                  </div>
                  <span className="font-black text-slate-600 whitespace-nowrap ml-4">
                    {opt.price === 0 ? "Zdarma" : `${opt.price} Kč`}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Info o době doručení */}
      <div className="mt-10 bg-blue-50/50 border border-blue-100 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-start gap-4 text-blue-900 shadow-sm">
        <Info className="w-8 h-8 text-blue-500 flex-shrink-0 mt-1" />
        <div>
          <strong className="block mb-2 text-lg">Zpracování objednávek</strong>
          <p className="text-slate-600 leading-relaxed font-medium">
            Všechny přijaté objednávky zpracováváme s maximální pečlivostí. Z důvodu nutnosti přesunu zboží z našeho skladu se snažíme vaše balíčky odesílat nejpozději do 3 pracovních dnů. Děkujeme za pochopení a trpělivost.
          </p>
        </div>
      </div>

    </div>
  );
};

export default ShippingPaymentPage;